import { render } from "./ClinicHistoryInputs.vue?vue&type=template&id=bb29d56e&scoped=true&ts=true"
import script from "./ClinicHistoryInputs.vue?vue&type=script&lang=ts"
export * from "./ClinicHistoryInputs.vue?vue&type=script&lang=ts"

import "./ClinicHistoryInputs.vue?vue&type=style&index=0&id=bb29d56e&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\src\\WebUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb29d56e"]])

export default __exports__